import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { StyledTitle, StyledLeadText, StyledCallout, StyledSection } from '@whitelabel/component-library';
import {
  gray as styleGray,
  themeColor,
  spacer,
  lineHeight,
  getThemeProp,
  multiply,
  mediaBreakpointUp,
  resetLinkStyle,
  fontFamily,
  zIndex,
} from '@whitelabel/helpers/style';

export const StyledLayout = styled.div<{ $rtl: boolean; $gray?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-bottom: 0;
  direction: ${({ $rtl }) => ($rtl ? 'rtl' : 'ltr')};

  ${({ $gray }) =>
    $gray
      ? css`
          background: ${styleGray(200)};
        `
      : css`
          h1${StyledTitle} {
            line-height: ${lineHeight('headingsLg')};
            margin-inline-end: ${multiply(spacer, 0.5)};
            margin-inline-start: ${multiply(spacer, 0.5)};

            ${mediaBreakpointUp('md')`
              margin-inline-end: ${spacer};
              margin-inline-start: ${spacer};
            `}

            span {
              background: ${themeColor('primary')};
              box-shadow: ${multiply(spacer, 0.5)} 0 0 ${themeColor('primary')},
                ${multiply(spacer, -0.5)} 0 0 ${themeColor('primary')};

              ${mediaBreakpointUp('md')`
                box-shadow: ${spacer} 0 0 ${themeColor('primary')}, -${spacer} 0 0 ${themeColor('primary')};
              `};
            }
          }

          ${StyledLeadText} {
            font-family: ${fontFamily('base')};
          }
        `}
`;
export const StyledHeader = styled.header<{
  $spacing?: 'lg';
  $hasBottomBorder: boolean;
  $hasHeaderMarginBottom: boolean;
}>`
  position: relative;
  z-index: ${zIndex('header')};
  ${({ $hasBottomBorder }) =>
    $hasBottomBorder &&
    css`
      border-bottom: ${getThemeProp('borderWidth')} solid ${styleGray(300)};
    `}

  ${mediaBreakpointUp('lg')`
    border-bottom: 0;
  `}

  ${({ $spacing, $hasHeaderMarginBottom }) =>
    $spacing === 'lg'
      ? css`
          margin-bottom: ${multiply(spacer, 1.5)};

          ${mediaBreakpointUp('md')`
            margin-bottom: ${$hasHeaderMarginBottom ? '2rem' : 0};
          `}

          ${mediaBreakpointUp('lg')`
            margin-bottom: ${$hasHeaderMarginBottom ? '3rem' : 0};
          `}
        `
      : css`
          margin-bottom: ${$hasHeaderMarginBottom ? spacer : 0};

          ${mediaBreakpointUp('md')`
            margin-bottom: ${$hasHeaderMarginBottom ? '2rem' : 0};
          `}

          ${mediaBreakpointUp('lg')`
            margin-bottom: ${$hasHeaderMarginBottom ? '3rem' : 0};
          `}
        `}

  a {
    ${resetLinkStyle}
  }
`;

StyledHeader.propTypes = {
  // @ts-ignore ts-migrate(2322) FIXME: Type '{ spacing: PropTypes.Requireable<string>; }'... Remove this comment to see the full error message
  spacing: PropTypes.oneOf(['lg']),
};

StyledHeader.defaultProps = {
  // @ts-ignore ts-migrate(2322) FIXME: Type '{ spacing: null; }' is not assignable to typ... Remove this comment to see the full error message
  spacing: null,
};

export const StyledMain = styled.div<{ $spacing?: 'lg' }>`
  display: flex;
  flex-direction: column;
  @media print {
    display: block;
  }

  ${({ $spacing }) =>
    $spacing === 'lg'
      ? css`
          margin-bottom: ${multiply(spacer, 4)};

          ${mediaBreakpointUp('md')`
          margin-bottom: ${multiply(spacer, 5)};
        `}

          ${mediaBreakpointUp('lg')`
          margin-bottom: ${multiply(spacer, 8)};
        `}

        ${StyledSection} {
            margin-bottom: ${multiply(spacer, 4)};

            ${mediaBreakpointUp('md')`
            margin-bottom: ${multiply(spacer, 5)};
          `}

            ${mediaBreakpointUp('lg')`
            margin-bottom: ${multiply(spacer, 8)};
          `}

          &:last-child {
              margin-bottom: 0;

              ${StyledCallout}:last-child {
                margin-bottom: -${multiply(spacer, 4)};

                ${mediaBreakpointUp('md')`
                margin-bottom: -${multiply(spacer, 5)};
              `}

                ${mediaBreakpointUp('lg')`
                margin-bottom: -${multiply(spacer, 8)};
              `}
              }
            }
          }
        `
      : css`
          margin-bottom: ${multiply(spacer, 1.5)};

          ${mediaBreakpointUp('md')`
            margin-bottom: ${multiply(spacer, 2)};
          `}

          ${mediaBreakpointUp('lg')`
            margin-bottom: ${multiply(spacer, 3)};
          `}
        `}
`;
